<template>
  <van-popup v-model="visible" round position="bottom">
    <template>
      <p class="title">壹心理咨询师入驻标准</p>
      <div class="content">
        <template v-for="(l, i) in list">
          <div v-if="i !== 1" class="list star-sign" :key="i">{{ l }}</div>
          <div v-else class="second star-sign" :key="i">
            <p>壹心理成熟咨询师入驻标准：</p>
            <ul>
              <li v-for="(html, i) in l" :key="i">
                <i>{{ `0${i + 1}` }}</i>
                <span v-html="html"></span>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <div class="btn" @click="visible = false">我知道了</div>
    </template>
  </van-popup>
</template>

<script>
import { Popup as VanPopup } from 'vant'
export default {
  components: {
    VanPopup
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get: ({ show }) => show,
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  data() {
    return {
      list: [
        '壹心理入驻咨询师，以2%甄选率的严苛标准，筛选出成熟专业、经验丰富的咨询师。来壹心理，找对的咨询师。',
        [
          '至少拥有一类 <strong>职业资格</strong>',
          '<strong>全日制本科</strong> 学历及以上（1999年后）',
          '付费个案经验 <strong>≥900</strong> 小时',
          '长程系统,培训时长 <strong>≥2</strong> 年',
          '个人体验时长 <strong>≥100</strong> 小时',
          '接受个体督导时长 <strong>≥60</strong> 小时',
          '需提交 <strong>12</strong> 次以上个案报告'
        ],
        '所有入驻咨询师都会经过3轮严格筛选、面试，并持续受壹心理及专家委员会监督，以保证心理咨询服务的专业性。'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #21252d;
  line-height: 36px;
  text-align: center;
  margin: 40px 0;
}
.content {
  padding-left: 80px;
  .list {
    width: 620px;
    font-size: 30px;
    color: #6c798c;
    line-height: 50px;
    margin-bottom: 30px;
  }
  .second {
    margin-bottom: 30px;
    color: #21252d;
    p {
      font-size: 32px;
      font-weight: 600;
      line-height: 52px;
      margin-bottom: 30px;
    }
    ul {
      display: flex;
      height: 564px;
      flex-direction: column;
      justify-content: space-between;
      li {
        position: relative;
        width: 620px;
        height: 72px;
        background: #f6f7ff;
        border-radius: 10px;
        font-size: 28px;
        line-height: 72px;
        i {
          display: inline-block;
          width: 82px;
          height: 72px;
          background: url(~images/platform/homepage/consult-standard-index.png)
            no-repeat;
          background-size: 100%;

          font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          line-height: 72px;
          padding-left: 18px;
          box-sizing: border-box;
          margin-right: 20px;
        }
      }
    }
  }
  .star-sign {
    position: relative;
    &::before {
      position: absolute;
      left: -48px;
      top: 10px;
      display: inline-block;
      content: '';
      width: 28px;
      height: 28px;
      background: url(~images/platform/homepage/consult-standard-star.png)
        no-repeat;
      background-size: 100%;
    }
  }
}
.btn {
  width: 686px;
  height: 86px;
  background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
  border-radius: 48px;
  margin: 10px auto 40px;

  font-size: 32px;
  font-weight: 600;
  color: #ffffff;
  line-height: 86px;
  text-align: center;
}
</style>
